import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ScanJourney from "@/pages/ScanJourney";
import FindDealer from "@/pages/FindDealer";
import AgentChat from "@/pages/AgentChat";
import AdminLayout from "@/admin/AdminLayout";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#8B0000]" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/scan" element={<ScanJourney />} />
          <Route path="/find-dealer/:token" element={<FindDealer />} />
          <Route path="/chat/:token" element={<AgentChat />} />
          <Route path="/admin/*" element={<Protected><AdminLayout /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
